import { Fragment, ReactNode } from 'react';

import { Typography } from '@/components/ui/typography/typography.component';

const emphasised = (name: string, key: string): ReactNode => (
  <Typography key={key} as="strong" className="text-inherit font-bold">{name}</Typography>
);

export function buildOutOfAgeRangeMessage(names: string[], formattedRange: string): ReactNode {
  if (names.length === 0) {
    return null;
  }

  const verb = names.length === 1 ? 'está' : 'estão';
  const suffix = ` ${verb} fora da faixa etária atendida (${formattedRange}).`;

  if (names.length === 1) {
    return (
      <>
        {emphasised(names[0], names[0])}
        {suffix}
      </>
    );
  }

  const head = names.slice(0, -1);
  const tail = names[names.length - 1];

  return (
    <>
      {head.map((name, index) => (
        <Fragment key={`${name}-${index}`}>
          {emphasised(name, `${name}-${index}`)}
          {index < head.length - 1 ? ', ' : ''}
        </Fragment>
      ))}
      {' e '}
      {emphasised(tail, tail)}
      {suffix}
    </>
  );
}
